webpackJsonp([263791100135453],{

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CareersModule = __webpack_require__(204);
	
	var _CareersModule2 = _interopRequireDefault(_CareersModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Careers = function Careers(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _CareersModule2.default.careers },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Careers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There are currently no openings, but resumes may be submitted to ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:inquiries@dom-sys.com' },
	        'inquiries@dom-sys.com'
	      )
	    )
	  );
	};
	
	exports.default = Careers;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"careers":"src-components-Careers----Careers-module---careers---271R8"};

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp":"(min-width: 700px)","white":"#FFFFFF","green":"#99C24D","wrapper":"src-pages----AboutPage-module---wrapper---58T8H","grid":"src-pages----AboutPage-module---grid---oH3Yh","overlay":"src-pages----AboutPage-module---overlay---l_tSo","body":"src-pages----AboutPage-module---body---2f2td","teamWrapper":"src-pages----AboutPage-module---teamWrapper---13hUS","team":"src-pages----AboutPage-module---team---2bJmq","people":"src-pages----AboutPage-module---people---2ooXu","person":"src-pages----AboutPage-module---person---1W7vh","position":"src-pages----AboutPage-module---position---ofp2B","meta":"src-pages----AboutPage-module---meta---VUlZb"};

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageWrapper = __webpack_require__(56);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _TextContainer = __webpack_require__(104);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _Inner = __webpack_require__(48);
	
	var _Inner2 = _interopRequireDefault(_Inner);
	
	var _Divider = __webpack_require__(47);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Careers = __webpack_require__(153);
	
	var _Careers2 = _interopRequireDefault(_Careers);
	
	var _AboutPageModule = __webpack_require__(635);
	
	var _AboutPageModule2 = _interopRequireDefault(_AboutPageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage(props) {
	  function createContent() {
	    return {
	      __html: props.data.about.edges[0].node.childMarkdownRemark.html
	    };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _AboutPageModule2.default.wrapper },
	    _react2.default.createElement('div', { className: _AboutPageModule2.default.overlay }),
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'About - Dominion Systems, LLC',
	      meta: [{
	        name: 'description',
	        content: 'Dominion Systems was established in 1989 and is locally owned and operated. We have extended our services to customers in 37 states and 5 countries.'
	      }]
	    }),
	    _react2.default.createElement(
	      _PageWrapper2.default,
	      null,
	      _react2.default.createElement(
	        _Inner2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _AboutPageModule2.default.grid },
	          _react2.default.createElement(
	            'div',
	            { className: _AboutPageModule2.default.body },
	            _react2.default.createElement(
	              _TextContainer2.default,
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                'About Dominion Systems'
	              ),
	              _react2.default.createElement(_Divider2.default, null),
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: createContent() })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _AboutPageModule2.default.teamWrapper },
	            _react2.default.createElement(
	              _TextContainer2.default,
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: _AboutPageModule2.default.team },
	                'Meet The Team'
	              ),
	              _react2.default.createElement(_Divider2.default, null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _AboutPageModule2.default.people },
	              props.data.team.edges.map(function (person) {
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    key: person.node.childMarkdownRemark.frontmatter.title,
	                    className: _AboutPageModule2.default.person
	                  },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    person.node.childMarkdownRemark.frontmatter.title
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: _AboutPageModule2.default.position },
	                    person.node.childMarkdownRemark.frontmatter.position
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: _AboutPageModule2.default.meta },
	                    person.node.childMarkdownRemark.frontmatter.phone,
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: 'mailto:' + person.node.childMarkdownRemark.frontmatter.email
	                      },
	                      'Email'
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _TextContainer2.default,
	              null,
	              _react2.default.createElement(_Careers2.default, null)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	var aboutQuery = exports.aboutQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-67dc846cd146800bce34.js